import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import HouseholdForm from "../components/HouseholdForm";
import { KeyRound } from "lucide-react";

export default function Onboarding() {
  const { loadHouseholds, selectHousehold } = useAuth();
  const navigate = useNavigate();
  const [code, setCode] = useState("");
  const [joining, setJoining] = useState(false);
  const join = async () => {
    setJoining(true);
    try { const { data } = await api.post("/households/join", { code: code.trim() }); await loadHouseholds(); selectHousehold(data.id); toast.success(`Welcome to ${data.name}! 🎉`); navigate("/home"); }
    catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
    finally { setJoining(false); }
  };
  const [loading, setLoading] = useState(false);

  const create = async (payload) => {
    setLoading(true);
    try {
      const { data: hh } = await api.post("/households", payload);
      await loadHouseholds();
      selectHousehold(hh.id);
      toast.loading("Millie is planning your week…", { id: "gen" });
      await api.post("/plan/generate", { household_id: hh.id });
      toast.success("Your week is sorted!", { id: "gen" });
      navigate("/plan");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Something went wrong", { id: "gen" });
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen w-full bg-[#F3EDE6] flex justify-center">
      <div className="relative w-full max-w-md min-h-screen bg-background">
        <div className="px-6 pt-8" data-testid="onboarding-join">
          <div className="bg-white rounded-3xl border-2 border-[#FFF3F0] shadow-soft p-4">
            <p className="text-sm font-bold text-sorted-ink flex items-center gap-1.5"><KeyRound size={15} strokeWidth={2.5} className="text-sorted-rose" /> Joining your partner's household? Enter their code</p>
            <div className="flex items-center gap-2 mt-2">
              <input data-testid="onboarding-join-input" value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} placeholder="6-letter code" maxLength={6}
                className="flex-1 min-w-0 bg-muted rounded-2xl px-3 py-2.5 text-sm font-bold tracking-widest text-sorted-ink outline-none focus:ring-2 focus:ring-sorted-peach uppercase" />
              <button onClick={join} disabled={joining || code.length < 6} data-testid="onboarding-join-btn" className="bg-sorted-rose disabled:opacity-40 text-white text-xs font-bold px-4 py-2.5 rounded-full">Join</button>
            </div>
          </div>
          <p className="text-center text-xs text-sorted-slate font-semibold mt-4">— or set up your own household below —</p>
        </div>
        <HouseholdForm onSubmit={create} loading={loading} submitLabel="Sort my week" />
      </div>
    </div>
  );
}
